module.exports = __webpack_public_path__ + "static/owl-5cab70b89f69adec52a476374c54615f.png";